<script>
import resources from './resources'

export default {
  name: 'event-detail',
  mixins: [resources]
}
</script>

<template lang="pug">
    .row
      .col-xs-12(v-if="(!schedule.id)")
        spinner(:show="true")
      .col-xs-12(v-if="!(!schedule.id)")
        .infos
          .col-xs-6.col-xs-offset-3.col-sm-2.col-sm-offset-0.col-md-offset-0.col-lg-offset-0
            img.img-circle(:src='professional.avatar')
          .col-xs-12.col-sm-7
            .row
              .col-xs-12.col-sm-7
                label.light-blue Profissional
                h3.medium-gray {{ professional.name }}
              .col-xs-12.col-sm-5
                label.light-blue N° de Registro
                h3.medium-gray CRM {{ professional.document }}-{{ professional.state }}
              .clearfix
              .col-xs-12
                label.light-blue Especialidades
                h4.medium-gray {{ specialities }}
              .col-xs-12.planos
                label.light-blue Convênios
                h4.medium-gray
                  span(v-for="c in covenants") {{ c.name }}
                  span.n-more(v-if="false") + 3
          .col-xs-12.col-sm-3
            label.light-blue Pontualidade
            .time-rating
              span.icon.active 
              span.icon.active 
              span.icon.active 
              span.icon.active 
              span.icon.active 
            label.light-blue Localização
            .location-rating
              span.icon.active 
              span.icon.active 
              span.icon.active 
              span.icon 
              span.icon 
            label.light-blue Ambiente
            .ambient-rating
              span.icon.active 
              span.icon.active 
              span.icon.active 
              span.icon.active 
              span.icon 
        .clearfix
        .next-event
          .col-xs-12
            h3.intro Próximo Evento Agendado
          .col-xs-12.col-sm-6
            label.light-blue Paciente
            h2.medium-gray(style='margin-bottom:10px;')
              | {{ patient.name }}
            label.light-blue Data e Hora
            h2.medium-gray(style='margin-bottom:10px;')
              | {{ schedule.date }}
              small.light-gray  às
              |  {{ schedule.time }}
            label.light-blue Convênio
            h3.medium-gray
              | {{ covenant }}
          .col-xs-12.col-sm-6
            label.light-blue Estabelecimento
            h3.medium-gray(style='margin-bottom:10px') {{ schedule.agenda.address.company.name }} - {{ schedule.agenda.address.name }}
            h4.light-gray(style='margin-bottom:10px') {{ schedule.agenda.address.label }} - {{ schedule.agenda.address.label2 }}
            maps(:latitude="schedule.agenda.address.latitude", :longitude="schedule.agenda.address.longitude")
        .clearfix
        .border-top.col-xs-12.col-sm-6.hidden-xs(style='padding-top:30px')
          label.light-blue.hidden-xs Unidades de Atendimento
        .border-top.col-xs-12.col-sm-6.text-center(style='padding-top:30px')
        .item(v-for="address in addresses")
          .col-xs-12.col-sm-6(v-if="address.schedules")
            h3.light-blue.hidden-sm.hiddem-md.hidden-lg Unidade de Atendimento
            label.light-gray Estabelecimento
            h3.gray {{ address.address.name }}
            h4.light-gray {{ address.address.label }} - {{ address.address.label2 }}
          .col-xs-12.col-sm-6
            .row
              .col-xs-12.col-sm-3(v-for="(schedules, index) in address.schedules")
                .row
                  .col-xs-3.col-sm-12
                    span.light-blue
                      | {{ index }}
                  .col-xs-9.col-sm-12(v-for="s in schedules")
                    span.light-gray {{ s.time }}
        // .clearfix
        // .col-xs-12
        //   .buttons-wrapper
        //     button.btn.save-filled(data-dismiss="modal", @click.prevent="doProfessionalProfile()")
        //       span.icon 
        //       |  Perfil do Profissional

        //     button.btn.save-filled(data-dismiss="modal", @click.prevent="doClose()")
        //      span.icon 
        //       |  Avaliar Estabelecimento
        //     button.btn.cancel-filled.hidden-sm.hidden-md.hidden-lg
        //       span.icon 
        //       |  Fechar
</template>



// WEBPACK FOOTER //
// src/app/patient/dashboard/gadget/components/upcoming/components/event-details/event-details.vue